import _ from 'lodash';

import { issuers } from './Issuers';
import { isProductionEnv, isSandboxEnv } from '../devOpsHelper/DevOps';

export const STRIPE_KEY_FOR_TEST_UK = 'pk_test_bO0dWx9Zspp5jH4EVmJfvzzJ';
const STRIPE_KEY_FOR_PRODUCTION_UK = 'pk_live_JZdjfhxdg1MvSpaVEZJCizGp';

export function getBankByIssuer(issuer) {
    const bankFound = _.find(issuers, (bank) => bank.regExp.test(issuer));

    if (bankFound) {
        return bankFound;
    }

    return {
        key: null,
        label: null
    };
}

export function handleStripeFieldComplete(action) {
    const { field } = action;

    switch (field) {
        case 'cardNumber':
            return {
                cardNumberComplete: true
            };
        case 'expiryDate':
            return {
                expiryDateComplete: true
            };
        case 'CVV':
            return {
                CVVComplete: true
            };
    }
}

export function clearStripeError(action) {
    const { field } = action;

    switch (field) {
        case 'cardNumber':
            return {
                invalidNumber: null,
                invalidCard: null,
                invalidCardType: null
            };
        case 'expiryDate':
            return {
                invalidExpiryDate: null
            };
        case 'CVV':
            return {
                invalidCVV: null
            };
        case 'billingPostcode':
            return {
                invalidPostcode: null
            };
    }
}

export function handlePaymentMethodErrors(error = {}) {
    switch (error.code) {
        case 'invalid_card_type':
            return {
                invalidCardType: true
            };
        case 'invalid_number':
        case 'incomplete_number':
            return {
                invalidNumber: true
            };
        case 'incomplete_expiry':
        case 'invalid_expiry_month':
        case 'invalid_expiry_year_past':
        case 'invalid_expiry_year':
            return {
                invalidExpiryDate: true
            };
        case 'invalid_cvc':
        case 'incomplete_cvc':
            return {
                invalidCVV: true
            };
        default:
            return {};
    }
}
export function getStripePublicKey() {
    if (isProductionEnv() && !isSandboxEnv()) {
        return STRIPE_KEY_FOR_PRODUCTION_UK;
    } else {
        return STRIPE_KEY_FOR_TEST_UK;
    }
}
